import styled from 'styled-components';
export const CloseContainer = styled.div `
    display: inline-block;
`;
